import {CaptchaService} from 'modules/yandexSmartCaptcha/services';
import {useEffect} from 'react';

export const useCaptchaConnectScript = () => {
    useEffect(() => {
        CaptchaService.connectScript();
    }, []);
};
